import { useSelector } from 'react-redux'

export { WS_STATUS } from '../reducers/conversationReducer'

export const useConversationWSStatus = () => (
  useSelector(state => state.conversation.ws_status)
)